export { default as ArticleSchema } from './article-schema.jsx';
